import "./ProgressBar.css";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  const getStepClassName = (step: number, currentStep: number) => {
    if (step < currentStep) {
      return "progress-bar-checked";
    }
    if (step === currentStep) {
      return "progress-bar-active";
    }
    return "progress-bar-future";
  };

  return (
    <div className="progress-bar">
      {steps.map((step, idx) => (
        <div className="progress-bar-step" key={step}>
          <div
            className={`progress-bar-circle ${getStepClassName(
              step,
              currentStep
            )}`}
          >
            {step < currentStep ? (
              <img
                src="/assets/icons/check-mark.svg"
                alt="check"
                width={16}
                height={11}
              />
            ) : (
              step
            )}
          </div>
          {idx < totalSteps - 1 && <div className="progress-bar-line" />}
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
